import { render } from "./ManagerClientList.vue?vue&type=template&id=4920106f"
import script from "./ManagerClientList.vue?vue&type=script&lang=js"
export * from "./ManagerClientList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__